import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import "./ds-tokens.css";
import "./ds-system.css";
import "./ds-kit.css";

// Tema escolhido no menu (claro/escuro). Sem escolha, segue o sistema.
try {
  const t = localStorage.getItem("rc2_tema");
  if (t === "light" || t === "dark") document.documentElement.setAttribute("data-theme", t);
} catch (e) { /* armazenamento bloqueado: segue o sistema */ }

ReactDOM.createRoot(document.getElementById("root")).render(<App />);
